import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import type { Token } from '@frontend/authentication-v2';
import { CreateOrder, Order, OrderListResponse, OrderQueryParams, UpdateOrder } from '@frontend/order/types';

export class OrderClient extends APIClient {
    public static readonly endpoint = '/order-api/v1';

    public static async fetchOrders(queryParams?: ApiQueryParams<OrderQueryParams>): Promise<OrderListResponse> {
        return await this.apiPaginated<OrderListResponse, OrderQueryParams>(`${this.endpoint}/orders`, queryParams);
    }

    public static async resolveOrders(ids: string[], field: string = 'id'): Promise<OrderListResponse> {
        return this.resolve<OrderListResponse>(`${this.endpoint}/orders`, ids, field);
    }

    public static async deleteOrders(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/orders-delete`, { ids });
        return await this.handleVoidResponse(response);
    }

    public static async postOrder(accountId: string, order: CreateOrder, withCredentials?: Token): Promise<Order> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/orders`, order, true, withCredentials);
        return await this.handleResponse<Order>(response);
    }

    public static async fetchOrder(accountId: string, orderId: string): Promise<Order> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/orders/${orderId}`);
        return await this.handleResponse<Order>(response);
    }

    public static async patchOrder(accountId: string, orderId: string, order: UpdateOrder): Promise<Order> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/orders/${orderId}`, order);
        return await this.handleResponse<Order>(response);
    }

    public static async deleteOrder(accountId: string, orderId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/orders/${orderId}`);
        return await this.handleVoidResponse(response);
    }
}
